export const AboutElementTypes = {
  Text: 'text',
  Video: 'video',
  Image: 'image',
  Carousel: 'carousel'
};
